import {
  UPDATE_FILTER_CONTRACTS_TOKEN,
  UPDATE_FILTER_CONTRACTS_PAGENUMBER,
  UPDATE_FILTER_CONTRACTS_SORT,
  UPDATE_FILTER_CONTRACTS_OBJECT,
  CLEAR_FILTER_CONTRACTS,
  UPDATE_CONTRACT_DATA,
  UPDATE_CONTRACTS_DATA,
  UPDATE_HOME_CONTRACTS_DATA,
  UPDATE_EVENT_FILE,
  UPDATE_HOLDINGS_FILE,
  UPDATE_RESEARCH_FILE,
  UPDATE_PORTFOLIO,
} from "~/actions/filter_contracts";
import { sentryWrappedException } from "~/utils/Utils";

// @ts-expect-error
const filter_contracts_reducer = (state, action) => {
  if (action.type === UPDATE_CONTRACT_DATA) {
    return {
      ...state,
      refreshContract: parseFloat(state.refreshContract) + 1,
    };
  }

  if (action.type === UPDATE_HOME_CONTRACTS_DATA) {
    return {
      ...state,
      refreshHomeContracts: parseFloat(state.refreshHomeContracts) + 1,
    };
  }

  if (action.type === UPDATE_CONTRACTS_DATA) {
    return {
      ...state,
      refreshContracts: parseFloat(state.refreshContracts) + 1,
    };
  }

  if (action.type === UPDATE_FILTER_CONTRACTS_TOKEN) {
    return {
      ...state,
      tokensContracts: !state.tokensContracts,
    };
  }

  if (action.type === UPDATE_FILTER_CONTRACTS_PAGENUMBER) {
    return {
      ...state,
      pageNumberContracts: action.payload,
    };
  }

  if (action.type === UPDATE_FILTER_CONTRACTS_SORT) {
    return {
      ...state,
      sortContracts: action.payload,
    };
  }

  if (action.type === UPDATE_FILTER_CONTRACTS_OBJECT) {
    const { name, value } = action.payload;
    return {
      ...state,
      filterContracts: {
        ...state.filterContracts,
        [name]: value,
      },
    };
  }

  if (action.type === CLEAR_FILTER_CONTRACTS) {
    const today = new Date();
    const threeMonthsFromToday = new Date(new Date().setMonth(new Date().getMonth() + 3));

    return {
      ...state,
      sortContracts: "oldest-contracts",
      pageNumberContracts: 1,
      filterContracts: {
        ...state.filters,

        // ALL CONTRACT FILTERS
        // search: "",
        // market: "finance_us",
        active: true,
        played: false,
        bids: [0, 10e8],
        prize: [0, 10e8],
        dates: [today, threeMonthsFromToday],

        // SPECIFIC TO MARKET FILTERS
        contracts: [],
        param1: [],
        param2: [],
        param3: [],
        param4: [],
        param5: [],
      },
    };
  }

  // PORTFOLIO
  if (action.type === UPDATE_EVENT_FILE) {
    return {
      ...state,
      eventFile: action.payload.signature,
      eventVerified: action.payload.verified,
    };
  }

  if (action.type === UPDATE_HOLDINGS_FILE) {
    return {
      ...state,
      holdingsFile: action.payload.signature,
      holdingsVerified: action.payload.verified,
    };
  }

  if (action.type === UPDATE_RESEARCH_FILE) {
    return {
      ...state,
      researchFile: action.payload.signature,
      researchVerified: action.payload.verified,
    };
  }

  if (action.type === UPDATE_PORTFOLIO) {
    return {
      ...state,
      portfolio: action.payload,
    };
  }

  const error = new Error(`No Matching "${action.type}" - action FILTER_CONTRACTS_REDUCER type`);
  sentryWrappedException(error);
  throw error;
};

export default filter_contracts_reducer;
